import {
  type DictationEditorId,
  type DictationStatus,
  sectionDictateStatusAtom,
  sectionDictateStatusAtomFamily,
} from '@/atoms/dictationAtom';
import { getDefaultStore } from 'jotai';

export const updateDictationAtomStatus = (
  updates: Partial<DictationStatus>,
  editorId?: DictationEditorId
) => {
  const jotaiStore = getDefaultStore();
  try {
    if (editorId) {
      const atom = sectionDictateStatusAtomFamily(editorId);
      const prev = jotaiStore.get(atom);
      jotaiStore.set(atom, {
        ...prev,
        ...updates,
      });
    }
    // Also update the legacy global atom for backwards compatibility
    const prev = jotaiStore.get(sectionDictateStatusAtom);
    jotaiStore.set(sectionDictateStatusAtom, {
      ...prev,
      ...updates,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to update dictation atom status', e);
  }
};

export const getDictationAtomStatus = (editorId?: DictationEditorId) => {
  const jotaiStore = getDefaultStore();
  if (editorId) {
    return jotaiStore.get(sectionDictateStatusAtomFamily(editorId));
  }
  return jotaiStore.get(sectionDictateStatusAtom);
};
